// Prize-claim share event — fires when a user shares their winnings
// from the prize-distribution dialog post-claim. Distinct from the
// PnL share events because the funnel question (did flexing claims
// drive new users vs flexing PnL) is the whole reason we track it.

import type { EventDefinition } from './navigation';
import type { PnlCardSharedMethod } from './pnl-card-shared';

export type PrizeClaimSharedProperties = {
  marketPubkey: string;
  walletPubkey: string;
  /** D6-encoded USDC amount claimed (BigInt-safe string). */
  amountD6: string;
  method: PnlCardSharedMethod;
};

export const PRIZE_CLAIM_SHARED: EventDefinition<PrizeClaimSharedProperties> = {
  name: 'prize_claim_shared',
};
